// Config compartida para @react-google-maps/api. useJsApiLoader() la usan tanto
// GeoPicker como CheckinMap — pasar siempre el mismo `id` y la misma referencia de
// `libraries` (un array vacío definido una sola vez, no uno nuevo en cada render) es lo
// que le permite a la librería reusar un único <script> de Google Maps entre los dos
// componentes en vez de intentar cargarlo dos veces y tronar con
// "You have included the Google Maps JavaScript API multiple times".
export const GOOGLE_MAPS_SCRIPT_ID = "chkr-google-maps-script";
export const GOOGLE_MAPS_LIBRARIES = [];
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
